import React from 'react';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import './NotFound.scss';

const NotFound = (): JSX.Element => {
  const navigate = useNavigate();

  return (
    <div className="notFound">
      <Result status="404" title="Erro 404" subTitle="Página não encontrada.">
        <Button
          type="primary"
          className="btn-go-back"
          onClick={
            (): void => {
              navigate('/');
            }
          }
        >
          VOLTAR À PÁGINA INICIAL
        </Button>
      </Result>
    </div>
  );
};

NotFound.propTypes = {};
NotFound.defaultProps = {};

export default NotFound;
